var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.list.length > 0
    ? _c(
        "div",
        [
          _c("h5", { staticClass: "text-primary text-uppercase" }, [
            _vm._v("offerte speciali")
          ]),
          _vm._v(" "),
          _c("h2", { staticClass: "mb-4" }, [
            _vm._v("L'occasione che stavi aspettando")
          ]),
          _vm._v(" "),
          _vm._l(_vm.list, function(item, index) {
            return _c(
              "div",
              {
                key: index,
                ref: "listRef",
                refInFor: true,
                staticClass: "mb-3"
              },
              [
                _vm.isMobile
                  ? _c("HorizontalItemTourMobile", {
                      attrs: {
                        disabled: true,
                        aereoporti: _vm.aereoporti,
                        value: item,
                        isHomePage: true
                      },
                      on: { select: _vm.onSelect }
                    })
                  : _c("HorizontalItemTour", {
                      attrs: {
                        disabled: true,
                        aereoporti: _vm.aereoporti,
                        value: item,
                        isHomePage: true
                      },
                      on: { select: _vm.onSelect }
                    })
              ],
              1
            )
          })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cc2830bc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc2830bc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/pages/home/OfferteSpeciali.vue
// module id = null
// module chunks = 